<template>
	<div class="side-menu">
		<v-navigation-drawer class="side-menu-container" width="450" v-model="open" overlay-opacity="0" right fixed app temporary>
            <div class="side-menu-close" @click="close()">
                <img src="@/assets/img/clear-white.png" width="21">
            </div>

			<div class="side-menu-directions">
				<div class="side-menu-transportation">
                    <span class="icon-walking" :class="{chosen: travelMode === 'WALKING'}" @click="changeTravelMode('WALKING')"></span>
					<span class="icon-bicycle" :class="{chosen: travelMode === 'BICYCLING'}" @click="changeTravelMode('BICYCLING')"></span>
					<span class="icon-tram" :class="{chosen: travelMode === 'TRANSIT'}" @click="changeTravelMode('TRANSIT')"></span>
                    <span class="icon-car" :class="{chosen: travelMode === 'DRIVING'}" @click="changeTravelMode('DRIVING')"></span>
				</div>

				<v-text-field ref="from" @focus="focus('from')" v-model="from" dark :label="__('side_menu_from')" placeholder="" class="mb-0 pb-0"></v-text-field>
				<v-text-field ref="to" @focus="focus('to')" v-model="to" dark :label="__('side_menu_to')" placeholder="" class="mt-0 pt-0"></v-text-field>
			</div>

			<div class="side-menu-calculations" v-if="calculatorCard">
                <h3 v-if="calculatorCard.type_options.side_menu_title">{{ calculatorCard.type_options.side_menu_title }}</h3>

				<Calculator :card="calculatorCard" :sideMenu="true" />
			</div>

            <div class="side-menu-info" v-html="__('side_menu_info')"></div>

			<div class="side-menu-layer" v-for="layer in sideLayers" :key="layer.id">
				<h3 class="side-menu-layer-title">{{ layer.__title }}</h3>
					
				<div class="side-menu-categories">
					<div class="side-menu-category" 
						v-for="category in filterUnique(layer.point_categories)" 
						:key="category.id"
						@click="toggleCategory(category, layer)"
						:class="{active: category.active}"
					>
						<div class="category-icon">
							<img v-if="category.icon && ! category.icon_font" :src="$imgUrl(category.icon)" />
							<i v-if="category.icon_font" class="card-fa" :style="{color: category.icon_font_color}" :class="category.icon_font"></i>
						</div>

						<div class="category-title">{{ __('point_category_' + category.id, category.title) }}</div>
					</div>

                    <div class="side-menu-category active"
                        v-for="kml in layer.kml_files"
                        :key="kml.key"
                    >
                        <div 
                            class="category-line"
                            :style="{'height': kml.thickness + 'px', 'background-color': kml.color}"
                        ></div>

                        {{ kml.description }}
                    </div>
				</div>
			</div>
		</v-navigation-drawer>
	</div>
</template>

<script>
import Calculator from '@/components/Calculator'

export default {
    name: 'SideMenu',
    components: {Calculator},

    data() {
        return {
            from: null,
            to: null,

            hasFocused: {
                to: false,
                from: false
            }
        }
    },

    watch: {
        directions: {
            handler(val, oldVal) {
                this.from = val.from
                this.to = val.to
            },
            deep: true,
            immediate: true
        }
    },

    mounted() {
        // Setup autocomplete
        let options = {componentRestrictions: {country: 'se'}}
        let autoComplete1 = new this.mapsApi.maps.places.Autocomplete(this.$refs.from.$el.querySelector('input'), options)
        let autoComplete2 = new this.mapsApi.maps.places.Autocomplete(this.$refs.to.$el.querySelector('input'), options)

        autoComplete1.addListener('place_changed', () => {
            this.$store.state.directions.from = autoComplete1.getPlace().formatted_address
        })

        autoComplete2.addListener('place_changed', () => {
            this.$store.state.directions.to = autoComplete2.getPlace().formatted_address
            this.$setCookie('toDestination', this.$store.state.directions.to)
        })
    },

    methods: {
        close() {
            this.open = false
        },

        focus(what) {
            if ( ! this.hasFocused[what]) {
                this[what] = ''
                this.hasFocused[what] = true
            }
        },

    	toggleCategory(category, layer) {
			category.active = ! category.active

            this.$metric({'event': 'layer_interaction', 'InteractionType': category.active ? 'activate' : 'deactivate', 'LayerType': layer.title, 'PointCategory': category.title, 'InteractionLocation': 'side-menu'})
    	},

    	changeTravelMode(travelMode) {
    		this.$store.state.directions.travelMode = travelMode

            this.$metric({'event': 'side-menu_interaction', 'InteractionType': 'directions', 'TransportationType': travelMode})
    	},

    	filterUnique(categories) {
    		let ids = []

    		return categories.filter(category => {
    			if (ids.includes(category.id)) {
    				return false
    			}
				
    			ids.push(category.id)

    			return true
    		})
    	}
    },

    computed: {
    	open: {
    	    get() { 
                this.$metric({'event': 'side-menu_interaction', 'InteractionType': this.$store.state.sideMenuOpen ? 'opened' : 'closed'})

                return this.$store.state.sideMenuOpen 
            }, 
    	    set(open) { this.$store.state.sideMenuOpen = open }
    	},

    	travelMode() {
			return this.$store.state.directions.travelMode
    	},

        directions() {
            return this.$store.state.directions
        },

    	mapsApi() {
    		return this.$store.state.mapsApi
    	},

        calculatorCard() {
            return this.$store.getters.cards
                .filter(c => c.type === 'calculator' 
                    && c.type_options.show_in_side_menu
                    && ( ! c.lang || c.lang === this.$store.state.endUser.language)
                )
                .find(Boolean)
        },

    	sideLayers() {
    		return this.$store.getters.translatedLayers
    			.filter(l => l.point_categories && l.point_categories.length > 0)
    	}
    }
}
</script>
